import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import Profile from "../components/Profile";
import { newAdminNavigation } from "../utils/helpers";
import AuthWrapper from "../platform/AuthWrapper";
import { Sidebar } from "./components/Sidebar";

function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const getPageTitle = () => {
    if (location.pathname === "/admin") {
      return "Admin Dashboard";
    }
    const currentNav = newAdminNavigation.find(
      (item) => item.href === location.pathname
    );
    return currentNav ? currentNav.name : "Admin Dashboard";
  };

  return (
    <AuthWrapper>
      <div className="flex min-h-screen bg-slate-50">
        {/* Mobile sidebar overlay */}
        {sidebarOpen && (
          <div
            className="fixed inset-0 z-40 bg-black bg-opacity-50 xl:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        {/* Sidebar */}
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        {/* Main content area */}
        <div className="flex-1 flex flex-col min-w-0 xl:ml-64">
          {/* Header - Sticky at top */}
          <header className="bg-white shadow-sm border-b border-slate-200 sticky top-0 z-30">
            <div className="flex items-center justify-between h-[63px] px-4 sm:px-6">
              <div className="flex items-center space-x-4">
                <button
                  onClick={() => setSidebarOpen(true)}
                  className="xl:hidden p-2 rounded-md hover:bg-slate-100 transition-colors flex items-center justify-center"
                >
                  <Menu className="w-5 h-5 text-slate-600" />
                </button>
                <div className="flex flex-col justify-center">
                  <h1 className="text-lg font-semibold text-slate-900 leading-tight">
                    {getPageTitle()}
                  </h1>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Profile />
              </div>
            </div>
          </header>

          {/* Main content */}
          <main className="flex-1 overflow-y-auto">
            <div className="p-4 sm:p-6 max-w-7xl mx-auto">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </AuthWrapper>
  );
}

export default AdminLayout;
